import { render, staticRenderFns } from "./SkillsSection.vue?vue&type=template&id=c45e936e&scoped=true"
import script from "./SkillsSection.vue?vue&type=script&lang=js"
export * from "./SkillsSection.vue?vue&type=script&lang=js"
import style0 from "./SkillsSection.vue?vue&type=style&index=0&id=c45e936e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45e936e",
  null
  
)

export default component.exports